import { takeLatest } from 'redux-saga/effects';
import getIdEventSaga from './getIdEventSaga';
import loadEventSaga from './loadEventSaga';
import saveEventSaga from './saveEventSaga';
import deleteEventSaga from './deleteEventSaga';
import setInviteEventSaga from './setInviteEventSaga';
import { TYPES } from '../constants';
import eventDeclineLinemenSaga from './eventDeclineLinemenSaga';
import updateEventStatusSaga from './updateEventStatusSaga';
import loadEventWithFiltersSaga from './loadEventWithFiltersSaga';

export default function* eventSagas(): Generator {
  yield takeLatest(TYPES.LOAD_EVENT.INIT, loadEventSaga);
  yield takeLatest(TYPES.LOAD_EVENT_WITH_FILTERS.INIT, loadEventWithFiltersSaga);
  yield takeLatest(TYPES.GET_ID_EVENT.INIT, getIdEventSaga);
  yield takeLatest(TYPES.SAVE_EVENT.INIT, saveEventSaga);
  yield takeLatest(TYPES.DELETE_EVENT.INIT, deleteEventSaga);
  yield takeLatest(TYPES.SET_INVITE_EVENT.INIT, setInviteEventSaga);
  yield takeLatest(TYPES.EVENT_DECLINE_LINEMEN.INIT, eventDeclineLinemenSaga);
  yield takeLatest(TYPES.UPDATE_EVENT_STATUS.INIT, updateEventStatusSaga);
}
